/* Neubau D · Kollektion und Suche.
   - [data-kcol-toggle] klappt das Filterfeld auf und zu (ohne JS ist es offen, siehe noscript).
   - Sortieren schickt das Formular sofort ab.
   - Beim Abschicken fallen leere Felder (z. B. ungenutzter Preis) aus der Adresse. */
(() => {
  const send = (form) => {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (String(v).trim() !== '') params.append(k, v);
    const qs = params.toString();
    window.location.href = form.action.split('?')[0] + (qs ? '?' + qs : '');
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-kcol-toggle]');
    if (!btn) return;
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-kcol-sort]');
    if (sel && sel.form) send(sel.form);
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-kcol-form]');
    if (!form) return;
    e.preventDefault();
    send(form);
  });
})();
